import { File } from "@/common/types/file";
import { LastReview } from "@/features/company/types/company.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "./maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceForwardingsCheckinEntryStepOptions } from "./maintenanceForwardingsShowDirectiveDetails.type";

export enum MaintenanceForwardingEstablishmentChoiceEntryProposalStatus {
  AwaitingEstablishmentResponse = 'awaiting_establishment_response',
  AwaitingClientResponse = 'awaiting_client_response',
}

export enum MaintenanceForwardingDirectiveEntryStatus {
  AwaitingManualStart = 'awaiting_manual_start',
}

export enum MaintenanceForwardingStatus {
  Canceled = 'canceled',
  OnGoingEstablishmentChoice = 'ongoing_establishment_choice',
  OnGoingCheckin = 'ongoing_checkin',
  OnGoingDirective = 'ongoing_directive',
}

export type MaintenanceForwardingEstablishmentChoiceEntryProposalData = {
  id: string;
  status: MaintenanceForwardingEstablishmentChoiceEntryProposalStatus;
  process_started_at: string | null;
  canceled_at: string | null;
  establishment_accepted_at: string | null;
  establishment_rejected_at: string | null;
  client_accepted_at: string | null;
  client_rejected_at: string | null;
  establishment: {
    id: string;
    general_information: {
      fantasy_name: string;
      company_logo: File;
    };
  };
  establishment_accepted_by: string | null;
  establishment_rejected_by: string | null;
  client_accepted_by: string | null;
  client_rejected_by: string | null;
}

export type MaintenanceForwardingEstablishmentChoiceEntryData = {
  id: string;
  actual_proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData;
  canceled_at: string | null;
  completed_at: string | null;
  establishment: {
    id: string;
    general_information: {
      fantasy_name: string;
      company_logo: File;
    };
  };
  process_started_at: string;
  status: string;
}

export type MaintenanceForwardingCheckinEntryData = {
  id: string;
  canceled_at: string | null;
  completed_at: string | null;
  created_at: string;
  delivery_code: string;
  equipment_usage_declaration: number | null;
  observations: string | null;
  process_started_at: string | null;
  responsible: {
    id: string;
    full_name: string;
  };
  status: string;
}

export type MaintenanceForwardingDirectiveEntryData = {
  canceled_at: string | null;
  completed_at: string | null;
  created_at: string;
  deadline_to_complete_in_days: number | null;
  last_review: LastReview;
  process_started_at: string | null;
  status: MaintenanceForwardingDirectiveEntryStatus;
  technical_response: {
    id: string;
    full_name: string;
  };
  total_value: string;
}

export type MaintenanceForwardingData = {
  canceled_at: string | null;
  checkin_entry: MaintenanceForwardingCheckinEntryData;
  checkin_entry_type: MaintenanceForwardingsCheckinEntryStepOptions;
  checkout_entry: null;
  completed_at: string | null;
  created_at: string;
  directive_entry: MaintenanceForwardingDirectiveEntryData;
  directive_entry_type: MaintenanceForwardingsDirectiveEntryKlass;
  establishment_choice_entry: MaintenanceForwardingEstablishmentChoiceEntryData;
  fiscal_assessment_entry: null;
  id: string;
  status: MaintenanceForwardingStatus;
  updated_at: string;
  workflow: {
    id: string;
  };
}

export type MaintenanceForwardingSectionsProps = {
  forwarding: MaintenanceForwardingData;
}
